import MessageNotifications from 'features/Notifications/components/MessageNotifications'
import {Fragment} from 'react'
import './index.scss'
import {useSelector} from 'react-redux'

const Notifications = () => {
    const listOfMessages = useSelector((state: any) => state.notification?.response)
    return (
        <>
            {listOfMessages?.map((msg) => (
                <MessageNotifications
                    key={msg.messageId}
                    messageId={msg.messageId}
                    messageType={msg.messageType}
                    messageTitle={msg.messageTitle}
                    descriptionHeader={msg.descriptionHeader}
                    description={msg.description}
                    carrier={msg.carrier}
                    displayFrom={msg.displayFrom}
                    displayTo={msg.displayTo}
                />
            ))}
        </>
    )
}

export default Notifications
